<template>
  <p class="font-medium"><slot></slot></p>
</template>
